// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const SettingsProvider = registerClientReference(
    function() { throw new Error("Attempted to call SettingsProvider() from the server but SettingsProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/contexts/settings-context.tsx",
    "SettingsProvider",
);
export const useSettings = registerClientReference(
    function() { throw new Error("Attempted to call useSettings() from the server but useSettings is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/contexts/settings-context.tsx",
    "useSettings",
);
